
const groupAllSelectors = document.querySelectorAll('[data-permission="all"]');
groupAllSelectors.forEach((element, index, parent) => {
  element.addEventListener('change', function () {
	let id = this.id;
	let isChecked = this.checked;
	let others = document.querySelectorAll(`[data-permission="${id}"]`);
	others.forEach((item, index, parent) => {
	  item.checked = isChecked;
	});
  });
});

const singleSelectors = document.querySelectorAll('[data-permission]:not([data-permission="all"]');
singleSelectors.forEach((element, index, parent) => {
  element.addEventListener('change', function () {
	let id = this.dataset.permission;
	let groupSelectors = document.querySelectorAll(`[data-permission="${id}"]`);
	let allChecked = true;
	groupSelectors.forEach((item, index, parent) => {
	  allChecked = allChecked && item.checked;
	});
	let groupSelector = document.querySelector(`#${id}`);
	if (groupSelector) {
	  groupSelector.checked = allChecked;
	}
  });
});

const roleSelect = document.querySelector('[data-roles]');
if (roleSelect) {
  roleSelect.addEventListener('change', function () {
	//Reset all checkbox
	document.querySelectorAll('[data-permission]')
	  .forEach(selector => { selector.checked = false; })

	let allOptions = roleSelect.querySelectorAll('option:checked');
	allOptions.forEach(option => {
	  if (option.value) {
		let values = option.value.split(',');
		values.forEach(value => {
		  let item = document.querySelector(`#${value}`);
		  item.checked = option.selected;
		  item.dispatchEvent(new Event('change'));
		});
	  }
	});
  });
}
